import React, { useEffect, useContext, useState } from 'react';
import { IconButton, Typography } from '@material-ui/core';
import Add from '@material-ui/icons/Add';
import { useHistory, useParams } from 'react-router-dom';
import { useToasts } from 'react-toast-notifications';
import useStyles from './styles';
import Contexts from '../../../../Contexts';
import LinkedAthleteTable from '../../../../Components/CommonTables/LInkedAtheteTable/LinkedAthleteTable';
import getAthletesByIds from '../../../../API/athletes/getAthletesByIds';
import getArticlesData from '../../../../API/articles/getArticlesData';
import removeArticleLinkedPlayer from '../../../../API/articles/removeArticleLinkedPlayer';

export default function ArticleLinkedPlayers() {
  const [athletesData, setAthletesData] = useState([]);
  const [articleData, setArticleData] = useState(null);
  const { showLoadingSpinner } = useContext(Contexts);
  const classes = useStyles();
  const { articleId } = useParams();
  const { addToast } = useToasts();

  const history = useHistory();

  const getArticle = async () => {
    showLoadingSpinner(true);
    const { article: fetchedArticle } = await getArticlesData(articleId);
    setArticleData(fetchedArticle);
    showLoadingSpinner(false);
  };

  const setLinkedAthletesDataFromArticle = async article => {
    showLoadingSpinner(true);
    try {
      const athletes = await getAthletesByIds(article.linked_athletes);
      setAthletesData(athletes);
    } catch (error) {
      console.error(error);
    }
    showLoadingSpinner(false);
  };

  useEffect(() => {
    getArticle();
  }, []);

  useEffect(() => {
    if (articleData) {
      setLinkedAthletesDataFromArticle(articleData);
    }
  }, [articleData]);

  const handleDeletePlayer = async playerId => {
    showLoadingSpinner(true);
    try {
      const updatedArticle = await removeArticleLinkedPlayer(
        articleId,
        playerId,
      );
      setArticleData(updatedArticle);
      showLoadingSpinner(false);

      addToast('deleted player', {
        appearance: 'success',
        autoDismiss: 500,
      });
    } catch (e) {
      showLoadingSpinner(false);
      addToast('error in deleting player', {
        appearance: 'error',
        autoDismiss: 500,
      });
    }
  };

  return (
    <div className={classes.root}>
      <div style={{ display: 'flex', textAlign: 'center' }}>
        <Typography variant="caption">
          This article will show up in the videos tab of these linked players
        </Typography>
      </div>

      <div style={{ display: 'flex' }}>
        <p style={{ marginRight: 10 }}>Add Players</p>
        <IconButton
          edge="start"
          className={classes.searchIcon}
          color="default"
          aria-label="menu"
          onClick={() => {
            history.push({
              pathname: `/articles/${articleId}/linked-players/add`,
            });
          }}
        >
          <Add />
        </IconButton>
      </div>

      {athletesData.length > 0 && (
        <div className={classes.editContainer}>
          <LinkedAthleteTable
            data={athletesData}
            onDeletePlayer={handleDeletePlayer}
          />
        </div>
      )}
    </div>
  );
}
